import React from 'react';

import classNames from 'classnames';

import Icon from '../icons/Icon';
import Label from '../Labels/Label';

import { getThemeColor } from '../../../utils/theme-utils';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export const StatCard = ({
  className, icon, header, content, subtitle, useTailwindSizing = false, isLoading = false,
}) => (
  <div className={classNames(
    'min-h-32 border shadow rounded relative',
    className,
  )}>
    {
      isLoading ? (
        <LoadingSpinner animationKey="model-list-spinner" size="medium" useOverlay />
      ) : null
    }
    <div className="px-2 py-2 flex flex-col items-start justify-between h-full">
      <div className="flex items-center justify-start">
        <Icon
          icon={icon}
          fill={getThemeColor('brand')}
          size={24}
          useTailwindSizing={useTailwindSizing}
        />
        <Label className="ml-2" size="md">{header}</Label>
      </div>
      <Label bold size="4xl">{content}</Label>
      <Label size="md">{subtitle}</Label>
    </div>
  </div>
);

export default StatCard;
